import React from 'react';

import DemoForm from './demo-form';

import './details-layout.scss';

const DemoGeneral = () => (
  <div styleName="details-layout">
    <div styleName="preview-container">
      <DemoForm />
    </div>
  </div>
);

export default DemoGeneral;
